<template>
  <div>
    <div class="literacy-content">
      <div class="literacy-head">
        <p class="literacy-number">4</p>
        <p class="cabin-family bold">Will you require the ability to access your investment for
        the purpose of withdrawing cash?</p>
      </div>

      <div class="literacy-body">
        <p class="semi-bold">For liquidity purposes, you may require the ability to withdraw your
          investments. Please choose from the most applicable option:</p>

        <div class="form-check">
          <input class="form-check-input" value="A" v-model="q4" type="radio"
          id="radio1">
          <label class="form-check-label">I will need to withdraw more than 75% of my investments in
          the next 12 months.</label>
        </div>

        <div class="form-check">
          <input class="form-check-input" value="B" v-model="q4" type="radio"
          id="radio1">
          <label class="form-check-label">I will need to withdraw more than 50% of my Investments in
            the next two to three years.</label>
        </div>

        <div class="form-check">
          <input class="form-check-input" value="C" v-model="q4" type="radio"
          id="radio1">
          <label class="form-check-label">I will need to withdraw more than 25% of my investments in
          the next couple of years</label>
        </div>

        <div class="form-check">
          <input class="form-check-input" value="D" v-model="q4" type="radio"
          id="radio1">
          <label class="form-check-label">I do not need to withdraw my investments to meet my
          liquidity needs.</label>
        </div>
      </div>

      <div class="literacy-footer text-center">
        <button class="btn primary-btn btn-block" :disabled="isDisabled" @click="next">Next</button>
        <p class="cabin-family bold mt-2" @click="previous">Previous</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    isDisabled() {
      if (!this.q4) {
        return true;
      }
      return false;
    },
  },
  data() {
    return {
      q4: '',
    };
  },
  methods: {
    next() {
      this.$emit('next', { q4: this.q4 });
    },
    previous() {
      this.$emit('previous');
    },
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped>

</style>
